/** Mirrors backend App\Enums\CapabilityCode — do not invent codes here. */
export const CAPABILITIES = {
  REPRICER: 'repricer',
  LABEL_EDITOR: 'label_editor',
  WB_INTEGRATION: 'wb_integration',
  LABEL_PRINTING: 'label_printing',
  UPD_DOCUMENTS: 'upd_documents',
  PRIORITY_SUPPORT: 'priority_support',
  PERSONAL_MANAGER: 'personal_manager',
  EARLY_ACCESS: 'early_access',
  ORGANIZATION_LIMIT: 'organization_limit',
  USER_LIMIT: 'user_limit',
  SKU_LIMIT: 'sku_limit',
  KIZ_MONTHLY: 'kiz_monthly',
} as const

export type CapabilityCode = (typeof CAPABILITIES)[keyof typeof CAPABILITIES]

export const CAPABILITY_LABELS: Record<string, string> = {
  [CAPABILITIES.REPRICER]: 'Репрайсер',
  [CAPABILITIES.LABEL_EDITOR]: 'Редактор этикеток',
  [CAPABILITIES.WB_INTEGRATION]: 'Интеграция с Wildberries',
  [CAPABILITIES.LABEL_PRINTING]: 'Печать этикеток',
  [CAPABILITIES.UPD_DOCUMENTS]: 'Работа с УПД',
  [CAPABILITIES.PRIORITY_SUPPORT]: 'Приоритетная поддержка',
  [CAPABILITIES.PERSONAL_MANAGER]: 'Персональный менеджер',
  [CAPABILITIES.EARLY_ACCESS]: 'Ранний доступ к новым функциям',
  [CAPABILITIES.ORGANIZATION_LIMIT]: 'Лимит организаций',
  [CAPABILITIES.USER_LIMIT]: 'Лимит пользователей',
  [CAPABILITIES.SKU_LIMIT]: 'Лимит товаров (SKU)',
  [CAPABILITIES.KIZ_MONTHLY]: 'КИЗ в месяц',
}

export function capabilityLabel(code: string): string {
  return CAPABILITY_LABELS[code] || code
}
